import React, { PureComponent } from 'react';
import { frontloadConnect } from 'react-frontload';
import { withRouter } from 'react-router';
import { connect } from 'react-redux';
import queryString from 'query-string';
import Waypoint from "react-waypoint";
import {Helmet} from 'react-helmet';
import PropTypes from 'prop-types';
import { compose } from 'redux';
import {dt} from 'l10n';

import isEmpty from 'lodash/isEmpty';

import Header from './header';
import ListItem from './listItem';

import './list.scss';
import {getAmateurFilms, getAmateurFilmTags, getAmateurFilmsTagged} from "reducers/amateurFilms";
import {getWallMaterials} from "reducers/wallMaterials";
import {getWardrobeMaterials} from "reducers/wardrobeMaterials";

const LIMIT = 30;

class MaterialList extends PureComponent {
  constructor(props) {
    super(props);
    const { order = 'date', slug } = this.constructor.getURLParams(props);
    let offset = 0;
    if (props.materials) {

      offset = props.materials.offset;
    }
    this.state = { offset: offset, order, slug, showModal: false };
  }

  static fetchData({dispatch, kind, params, videos}) {

    if (kind == "videos") {
      if (params.slug) {
        return dispatch(getAmateurFilmsTagged({ ...params }))
      }
      return Promise.all([
          dispatch(getAmateurFilms({...params})),
          dispatch(getAmateurFilmTags())
      ])
    } else if (kind == "wardrobe") {
      return dispatch(getWardrobeMaterials({...params, kind : "wardrobe" }))
    } else {
      return dispatch(getWallMaterials({...params, kind : "wall" }))
    }
  }

  static getURLParams = props => {
    const { match, location: { search }} = props;
    const { order = 'date' } = queryString.parse(search);
    return { order, slug: match.params.slug };
  };

  componentDidMount() {
    const { materials } = this.props;
    if (isEmpty(materials.list)) {
      this.loadMaterials();
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { order, slug } = this.state;
    if ((order !== prevState.order) || (slug !== prevState.slug)) {
      this.setState({ offset: 0 });
      this.loadMaterials();
    }
  }

  componentWillReceiveProps(nextProps) {
    const prevSlug = this.state.slug;
    const {materials} = this.props;
    const {order, slug} = this.constructor.getURLParams(nextProps);
    if (prevSlug !== slug) {
      this.setState({offset: 0});
    }
    if (materials.isLoading && !nextProps.materials.isLoading) {
      this.setState({offset: nextProps.materials.offset});
    }
    this.setState({order, slug});
    
  }

  loadMaterials = infinite => {
    const { order, offset, slug } = this.state;
    const { dispatch, kind, location, videos } = this.props;
    const params = { offset, order, kind, infinite, slug, limit: LIMIT };
    this.constructor.fetchData({ dispatch, kind, location, params, videos });
  };

  updateOrder = order => {
    const { history, location } = this.props;

    this.setState({ order, offset: 0 });
    history.push(location.pathname + '?' + queryString.stringify({ order }));
  };

  onWayPointEnter = () => {
    const { materials: { totalCount, isLoading }} = this.props;
    const { offset, slug } = this.state;
    if (!isLoading && offset < totalCount && !slug) {
      this.loadMaterials(true);
    }
  };



  render() {
    const { order } = this.state;
    const { materials, videos, kind } = this.props;
    let title = videos ? 'Amateur videos of bobbesies and bobbers' :
                    'The wall  of BobTV, photos and videos posted by members';
    if (kind == 'wardrobe') {
      title = 'Bobstore Wardrobe';
    }

    return(
      <div id="wrapper">
        <Helmet>
          <title>
            {dt('meta', title)}
          </title>
        </Helmet>
        <Header order={order} changeOrder={this.updateOrder} videos={videos} materials={materials} kind={kind}/>
        <div className="materials">
          <div className="content ui-responsive-grid">
            {!isEmpty(materials.list) && materials.list.map(material =>
                <ListItem material={material} key={material.id} tag={materials.tag} type={videos ? 'video' : 'wall'} order={order} showDate showStats />
            )}
          </div>
          <Waypoint onEnter={() => this.onWayPointEnter()} />
        </div>
      </div>
    )
  }
}

MaterialList.propTypes = {
  videos: PropTypes.bool.isRequired,
  match: PropTypes.object.isRequired,
  history: PropTypes.object.isRequired,
  location: PropTypes.object.isRequired,
  materials: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => {
  const { location: { pathname }} = ownProps;
  const videos = pathname.includes('films-amateurs');
  const wardrobe = pathname.includes('wardrobe');
  let result = { videos: videos };
  switch (ownProps.kind) {
    case 'wardrobe': result.materials = state.wardrobeMaterials; break;
    case 'videos': result.materials = state.amateurFilms; break;
    case 'wall': result.materials = state.wallMaterials; break;
    default: result.materials = state.wallMaterials; break;
  }
  return result;
};

const frontloadFunction = async (props) => {
  const {dispatch, videos} = props;
  const {order, slug} = MaterialList.getURLParams(props);

  const params = { order, slug, limit: LIMIT};
  await MaterialList.fetchData({ dispatch, params, videos });
};

export default compose(
    withRouter,
    connect(mapStateToProps),
    frontloadConnect(frontloadFunction)
)(MaterialList)



// WEBPACK FOOTER //
// ./src/components/materialList/index.js